var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    transactionId: '',
    referenceNumber: '',
    transactionCode: '',
    transactionDate: '',
    transactionAmount: '',
    statementDate: '',
    merchantName: '',
    merchantDesc: ''
};
var transactionDataSlice = createSlice({
    name: 'transactionData',
    initialState: initialState,
    reducers: {
        updateTransactionData: function (state, action) {
            var payload = action.payload;
            var statementDate = payload.statementDate;
            return __assign(__assign(__assign({}, state), payload), { statementDate: statementDate || null });
        },
        clearTransactionData: function () {
            return initialState;
        }
    }
});
export var updateTransactionData = (_a = transactionDataSlice.actions, _a.updateTransactionData), clearTransactionData = _a.clearTransactionData;
export default transactionDataSlice.reducer;
//# sourceMappingURL=transactionData.slice.js.map